import { render } from "./calc.vue?vue&type=template&id=bb086762"
import script from "./calc.vue?vue&type=script&lang=js"
export * from "./calc.vue?vue&type=script&lang=js"

import "./calc.vue?vue&type=style&index=0&id=bb086762&lang=css"

import exportComponent from "D:\\work\\work\\project\\intelegent\\ips\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__